export const formatNumber = (number, thousandSymbol = ',', decimalSymbol = '.') => {
    // Ensure the number is a valid finite number
    if (number == undefined) return;

    // Split the number into integer and decimal parts
    let splitDecimal = number.includes(decimalSymbol) ? decimalSymbol : '.';
    const [integerPart, decimalPart] = number.toString().split(splitDecimal);

    if(number.includes(thousandSymbol) && number.includes(decimalSymbol) && decimalPart.length == 2) return;
  
    // Add commas for the integer part
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSymbol);
  
    // If there's no decimal part, add '00' for the decimal symbol
    const formattedDecimal = decimalPart ? decimalPart.length == 1 ? decimalPart + "0" : decimalPart : '00';
  
    // Combine integer and decimal parts
    return `${formattedInteger}${decimalSymbol}${formattedDecimal}`;
  };